import React, { createContext, useState, useContext } from 'react';
import translations from '../translations';

// Create a context for language
const LanguageContext = createContext();

// Create a provider component
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('EN');
  const [direction, setDirection] = useState('ltr');
  
  // Function to change language
  const changeLanguage = (langCode) => {
    setLanguage(langCode);
    // Set RTL direction for Arabic
    setDirection(langCode === 'AR' ? 'rtl' : 'ltr');
    // You could also persist this choice in localStorage
    localStorage.setItem('preferredLanguage', langCode);
  };
  
  // Get translation for a specific key
  const t = (key) => {
    // Get the current language translations
    const currentTranslations = translations[language] || translations.EN;
    
    // Find the translation for the key or fallback to the key itself
    return currentTranslations[key] || key;
  };
  
  return (
    <LanguageContext.Provider value={{ language, direction, t, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook for using the language context
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext; 